<script setup>
import useInStorageTable from "./hooks/useInStorageTable";
import Adjust from "./adjust.vue";
import { PROCESS_STATUS, TAG_TYPE, PIAO_STATUS } from "@/constants";
import useStashList from "../../hooks/useStashList";
import { onMounted, ref } from "vue";
import { queryDictList } from "@/api/dict";
import { DICT_KEY } from "@/constants/dict";
import { importBound } from "@/api/bound";
import { querySupplierData } from "@/api/supplier";

const { stashList } = useStashList();

const inStorageTypeList = ref([]);

const {
  searchRef,
  searchData,
  columns,
  tableData,
  statistics,
  tableLoading,
  pages,
  editRef,
  datePicker,
  tableRef,
  handleReset,
  getList,
  handleSizeChange,
  handleCurrentChange,
  handleAdjust,
  handleExport,
  datePickerChange,
  handleSelectionChange,
  handleBatchDelete,
  cancerMarkers,
  markers,
  handleProcess,
  handleUpload,
  uploadRef,
  uploadConfig,
} = useInStorageTable();

onMounted(() => {
  getList();
  getData();

  queryDictList(DICT_KEY["boundTypeIn"]).then((res) => {
    inStorageTypeList.value = res.data || [];
  });
});

const supplierList = ref([]);
const getData = async () => {
  try {
    const res = await querySupplierData();
    supplierList.value = res.data;
  } catch (error) {
    console.error(error);
  }
};
</script>

<template>
  <zh-table-page v-bind="{ title: '入库管理' }">
    <template #header-btn
      ><el-button type="primary" icon="Plus" @click="handleAdjust(null, '0')"
        >新增</el-button
      ></template
    >
    <template #search>
      <el-form :model="searchData" ref="searchRef" label-width="90px">
        <el-row :gutter="10">
          <el-col :span="5">
            <el-form-item label="入库单号：" prop="number">
              <el-input v-model="searchData.number" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="入库类型：" prop="type">
              <el-select
                v-model="searchData.type"
                placeholder="请选择"
                style="width: 90%"
              >
                <el-option
                  v-for="item in inStorageTypeList"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="入库仓库：" prop="warehouseId">
              <el-select
                v-model="searchData.warehouseId"
                placeholder="请选择"
                style="width: 90%"
              >
                <el-option
                  v-for="item in stashList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="物料名称：" prop="materialNameText">
              <el-input
                v-model="searchData.materialNameText"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="供应商：" prop="supplier">
              <el-select
                v-model="searchData.supplier"
                filterable
                placeholder="请选择"
                style="width: 240px"
              >
                <el-option
                  v-for="item in supplierList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="审核状态：" prop="processStatus">
              <el-select
                v-model="searchData.processStatus"
                placeholder="请选择"
                style="width: 90%"
              >
                <el-option
                  v-for="item in PROCESS_STATUS"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="开票状态" prop="invoicingStatus">
              <el-select
                v-model="searchData.invoicingStatus"
                placeholder="请选择"
                style="width: 90%"
              >
                <el-option
                  v-for="item in PIAO_STATUS"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="6" :sm="8">
            <el-form-item label="入库时间：">
              <el-date-picker
                v-model="datePicker"
                type="datetimerange"
                placeholder="请选择"
                style="width: 100%"
                @change="datePickerChange"
                format="YYYY-MM-DD HH:mm:ss"
                value-format="YYYY-MM-DD HH:mm:ss"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
              />
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item> </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>
    <template #table>
      <!-- <el-button icon="Delete" @click="handleBatchDelete(null, true)"
        >批量删除</el-button
      > -->
      <el-button icon="Upload" @click="handleUpload()">导入</el-button>
      <el-button icon="Download" @click="handleExport()">导出</el-button>
      <el-button @click="markers()">标记开票</el-button>
      <el-button @click="cancerMarkers()">取消开票</el-button>
      <el-button type="primary" icon="Search" @click="getList()"
        >查询</el-button
      >
      <el-button icon="Refresh" @click="handleReset()">重置</el-button>
      <div class="total">
        <span>入库总单数: {{ statistics.count || 0 }}</span>
        <span class="price"
          >合计入库物料总价: {{ statistics.totalPrice || 0 }}元</span
        >
      </div>
      <el-table
        ref="tableRef"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{
          'text-align': 'center',
        }"
        style="width: 100%; margin-top: 10px"
        max-height="520"
        v-loading="tableLoading"
        :data="tableData"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" />
        <template v-for="item in columns" :key="item.prop">
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            :min-width="120"
            show-overflow-tooltip
          >
            <template #default="{ row }">
              <el-tag
                :type="TAG_TYPE[row[item.prop]?.value]"
                v-if="
                  item.prop == 'processStatus' ||
                  item.prop == 'invoicingStatus' ||
                  item.prop == 'boundType'
                "
                >{{ row[item.prop]?.desc }}</el-tag
              >
              <span v-else>{{ row[item.prop] || "-" }}</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="操作" width="150" fixed="right">
          <template #default="{ row }">
            <el-button type="primary" link @click="handleAdjust(row, 2)"
              >查看</el-button
            >
            <el-button
              type="primary"
              link
              @click="handleAdjust(row, 1)"
              v-if="
                row.processStatus.value == 1 || row.processStatus.value == 4
              "
              >编辑</el-button
            >
            <el-button
              type="danger"
              link
              @click="handleBatchDelete(row.id, false)"
              v-if="
                row.processStatus.value == 1 || row.processStatus.value == 4
              "
              >删除</el-button
            >
            <el-button
              type="danger"
              link
              @click="handleProcess(row.approvalId, false)"
              v-if="
                row.processStatus.value == 1 || row.processStatus.value == 4
              "
              >提交审核</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="pages.total > 0"
        background
        style="margin-top: 10px"
        :current-page="pages.page"
        :page-size="pages.size"
        :page-sizes="[10, 20, 30, 50]"
        :total="pages.total"
        layout="->, total, prev, pager, next, sizes, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </template>
  </zh-table-page>
  <!-- 新增入库 -->
  <Adjust ref="editRef" @after-save="getList" />

  <!-- 导入组件 -->
  <FileUpload
    ref="uploadRef"
    @afterUpload="getList"
    :fn="importBound"
    :uploadConfig="uploadConfig"
  />
</template>

<style lang="less" scoped>
.total {
  display: inline-block;
  color: #409eff;
  margin-left: 20px;
  font-size: 12px;
  .price {
    margin-left: 20px;
  }
}
</style>
